module.exports = __webpack_public_path__ + "img/q2-father.54b3d220.svg";